/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default [
  {
    url: "/organization/home",
    routeName: "org-home",
    name: "Dashboard",
    slug: "dashboard",
    icon: "GridIcon",
  },
  {
    url: "/organization/reviews",
    routeName: "org-reviews",
    name: "Reviews",
    slug: "reviews",
    icon: "UserCheckIcon",
    // alpha: true,
  },
  // {
  //   url: "/organization/planner",
  //   routeName: "org-planner",
  //   name: "Planner",
  //   slug: "planner",
  //   icon: "CalendarIcon",
  // },
  // {
  //   url: "/comm/home",
  //   routeName: "comm-server",
  //   name: "Comm Server",
  //   slug: "comm-server",
  //   icon: "MessageSquareIcon",
  //   target: "_blank"
  // },
  {
    url: "/organization/board-templates",
    routeName: "org-board-templates",
    name: "Board Templates",
    slug: "board-templates",
    icon: "ArchiveIcon",
  },
  {
    url: "/organization/marketplace",
    routeName: "org-marketplace",
    name: "Apps and Configs",
    slug: "apps",
    icon: "ShoppingBagIcon",
  },
  {
    url: "/organization/admins",
    routeName: "org-admins",
    name: "Admins",
    slug: "admins",
    icon: "UserIcon",
  },
  {
    url: "/organization/users",
    routeName: "org-users",
    name: "Community",
    slug: "users",
    icon: "UsersIcon",
    alpha: true,
  },
  {
    url: "/organization/treasury",
    routeName: "org-treasury",
    name: "Treasury",
    slug: "treasury",
    icon: "DollarSignIcon",
    alpha: true,
  },
  // {
  //   url: "/organization/reports",
  //   routeName: "org-reports",
  //   name: "Reports",
  //   slug: "reports",
  //   icon: "ZapIcon",
  // },
  // {
  //   url: "/organization/dashboard?activity=true",
  //   routeName: "org-activity",
  //   name: "Activity",
  //   slug: "activity",
  //   icon: "ActivityIcon",
  // }
  // {
  //   url: null,
  // 	name: "More",
  // 	slug: "show-more",
  // 	icon: "HomeIcon",
  // 	submenu: [
  // 		{
  // 			url: '/organization/archived-boards',
  // 			name: "Archived Boards",
  // 			slug: "archived-boards",
  // 			i18n: "ArchivedBoards",
  // 		}
  // 	]
  // }
];
